// ============================================================================
// PAYMENT HELPERS (Razorpay Subscriptions / autopay)
// The browser only authorises the mandate; the server + Razorpay webhook are
// the source of truth for whether autopay is actually live.
// ============================================================================

const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";

// Load the Razorpay checkout script once. Resolves true when window.Razorpay
// is available.
export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (typeof window !== "undefined" && window.Razorpay) return resolve(true);
    const existing = document.querySelector(`script[src="${RAZORPAY_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => resolve(false));
      return;
    }
    const script = document.createElement("script");
    script.src = RAZORPAY_SRC;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

// ₹ formatter — whole rupees, grouped Indian-style.
export const fmtINR = (amount) => {
  const n = Number(amount || 0);
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};
